import $ from 'jquery'
import _throttle from 'lodash/throttle'
import { isElementVisible } from './visibility'
import { toggleMenu } from './menu'

let parallaxElements = []
let parallaxBackgroundElements = []
let horizontalBackgroundElements = []
let windowWidth = 1000
let windowHeight = 800
let documentHeight = 800
let scrollPosition = 0
let lastScrollPosition = 0

let hrs = []
let menuOpenedFromBottom = false
const allowMenuOpenFromBottom = window.allowMenuOpenFromBottom || false
const formTags = ['INPUT', 'TEXTAREA', 'SELECT']

const $backToTop = $('[data-back-to-top]')

const $yourNames = $('.wedding-form input#your-name')

export function init() {
  reinit()

  $backToTop.on('click', function () {
    $('html, body').animate({ scrollTop: 0 }, 1000, 'swing')
  })

  $(document).on('scroll', _throttle(handleScroll, 1000 / 60))
  $(window).on(
    'resize',
    _throttle(() => {
      handleResize()
      handleScroll()
    }, 1000 / 30)
  )

  $(document).on('ready', () => {
    handleResize()
    handleScroll()
  })
}

export function reinit() {
  // reset elements
  parallaxElements = []
  parallaxBackgroundElements = []
  horizontalBackgroundElements = []

  // build out elements array
  $('[data-scroll-offset]').each((i, elem) => {
    const $elem = $(elem)
    const offsetY = $elem.data('scroll-offset')
    const rotate = $elem.data('scroll-rotate') || 0
    parallaxElements.push({
      $elem,
      offsetY,
      rotate,
    })
  })
  $('[data-scroll-offset-x]:not([data-scroll-offset-y])').each((i, elem) => {
    const $elem = $(elem)
    const offsetX = $elem.data('scroll-offset-x')
    const rotate = $elem.data('scroll-rotate') || 0
    parallaxElements.push({
      $elem,
      offsetX,
      rotate,
    })
  })
  $('[data-scroll-offset-y]:not([data-scroll-offset-x])').each((i, elem) => {
    const $elem = $(elem)
    const offsetY = $elem.data('scroll-offset-y')
    const rotate = $elem.data('scroll-rotate') || 0
    parallaxElements.push({
      $elem,
      offsetY,
      rotate,
    })
  })
  $('[data-scroll-offset-x][data-scroll-offset-y]').each((i, elem) => {
    const $elem = $(elem)
    const offsetX = $elem.data('scroll-offset-x')
    const offsetY = $elem.data('scroll-offset-y')
    const rotate = $elem.data('scroll-rotate') || 0
    parallaxElements.push({
      $elem,
      offsetX,
      offsetY,
      rotate,
    })
  })

  // build out elements array
  $('[data-background-scroll-offset]').each((i, elem) => {
    const $elem = $(elem)
    const offset = $elem.data('background-scroll-offset')
    parallaxBackgroundElements.push({
      $elem,
      offset,
    })
  })

  // build out elements array
  $('[data-background-scroll-offset-x]').each((i, elem) => {
    const $elem = $(elem)
    const offset = $elem.data('background-scroll-offset-x')
    horizontalBackgroundElements.push({
      $elem,
      offset,
    })
  })

  // create list of hr sections
  $('section.hr-section.hr-section-right:not(.hr-section-basic)').each((i, elem) => {
    const $elem = $(elem)
    $elem.append($('<div class="arrow arrow-left"><img src="/assets/glyphs/arrow-right.svg" /></div>'))
    $elem.append($('<div class="arrow arrow-right"><img src="/assets/glyphs/arrow-left.svg" /></div>'))
    hrs.push({
      offset: $elem.find('a.button').outerWidth() / 2,
      $hr: $elem,
      $left: $elem.find('.arrow-left'),
      $right: $elem.find('.arrow-right'),
    })
  })

  // run once to position elements
  handleResize()
  handleScroll()
}

function handleResize() {
  windowWidth = $(window).width()
  windowHeight = $(window).height()
  documentHeight = $(document).height()
}

function handleScroll() {
  scrollPosition = $(document).scrollTop()

  // update hr position
  for (let hr of hrs) {
    const elementOffset = hr.$hr.offset()
    const diff = elementOffset.top - 200 - scrollPosition
    let offset = 100 - (diff / (windowHeight * 0.8)) * 100
    offset = Math.max(0, Math.min(100, offset))

    hr.$left.css('left', 'calc(' + (-50 + offset / 2) + 'vw - ' + hr.offset + 'px)')
    hr.$right.css('right', 'calc(' + (-50 + offset / 2) + 'vw - ' + hr.offset + 'px)')
  }

  // update back-to-top
  if (scrollPosition > 3500) {
    if (!$backToTop.hasClass('active')) $backToTop.addClass('active')
  } else {
    if ($backToTop.hasClass('active')) $backToTop.removeClass('active')
  }

  for (let element of parallaxBackgroundElements) {
    // const elementOffset = element.$elem.offset()
    // const elementTop = elementOffset.top
    // const posY = elementTop + element.$elem.height() / 2
    const diff = scrollPosition / (100 / element.offset)
    const offset = diff
    element.$elem.css({ 'background-position': `0 ${offset}px` })
  }

  for (let element of horizontalBackgroundElements) {
    const diff = scrollPosition / (100 / element.offset)
    const offset = diff
    element.$elem.css({ 'background-position': `${offset}px 0` })
  }

  // get outta here! no parallax or bottom page menu on mobile pls
  if ($(window).width() < 450 && window.location.href.indexOf('openseason') < 0) return

  // focus 'your-name' wedding form field when scrolling past
  const $activeElem = $(document.activeElement)
  $yourNames.each((i, elem) => {
    const $elem = $(elem)
    const elementOffset = $elem.offset()
    const diff = scrollPosition + windowHeight - elementOffset.top
    if (
      document.activeElement != elem &&
      formTags.indexOf(document.activeElement.tagName) < 0 &&
      diff >= 150 &&
      diff <= windowHeight - 150
    ) {
      $elem.focus()
    } else if (document.activeElement == elem && (diff < 150 || diff > windowHeight - 150)) {
      $elem.blur()
    }
  })

  // check if menu should open from bottom of page
  if (allowMenuOpenFromBottom) {
    const scrollBottom = documentHeight - windowHeight
    if (scrollPosition >= scrollBottom - 20) {
      if (!menuOpenedFromBottom && scrollPosition - lastScrollPosition >= 2) {
        toggleMenu(null)
        menuOpenedFromBottom = true
      }
    } else {
      if (menuOpenedFromBottom && scrollPosition - lastScrollPosition <= -2) {
        toggleMenu(null)
        menuOpenedFromBottom = false
      }
    }
  }

  lastScrollPosition = scrollPosition

  // process parallax
  const centerScreen = scrollPosition + windowHeight / 2
  for (let element of parallaxElements) {
    if (isElementVisible(element.$elem, 0.5)) {
      const elementOffset = element.$elem.offset()
      const elementTrans =
        element.$elem.css('transform') != 'none'
          ? element.$elem.css('transform').split(',').map(parseFloat)
          : [0, 0, 0, 0, 0, 0, 0, 0]
      const elementTop = elementOffset.top - elementTrans[5]
      const posY = elementTop + element.$elem.height() / 2
      const diffX = element.offsetX ? (centerScreen - posY) / (100 / element.offsetX) : 0
      const diffY = element.offsetY ? (centerScreen - posY) / (100 / element.offsetY) : 0
      const diffRotate = element.rotate ? (centerScreen - posY) / (100 / element.rotate) : 0

      const transform = `translate(${diffX}px, ${diffY}px) rotate(${diffRotate}deg)`
      element.$elem.css({ transform: transform, '-webkit-transform': transform })
    }
  }
}
